// Canonical builder for the `projectContext` object the backend requirement
// filter consumes (requirementsExtractionWorker._clause_matches_project reads
// constructionType / sprinklerSystem / allOccupancyCodes|majorOccupancyCode).
//
// This mirrors the shape ClassifierModal sends on /classifier/confirm so the
// re-filter path projects against the exact same context the original
// extraction used. Keep the two in sync if the confirm payload changes.
export function buildProjectContext(project, opts = {}) {
  if (!project) return {};
  const { zoningFallback = '', constructionTypeFallback = null } = opts;

  const ctx = {
    jurisdiction:           project.occupancyRegion,
    majorOccupancyCode:     project.majorOccupancy,
    zoningDesignation:      project.zoningDesignation || (zoningFallback || '').trim(),
    allOccupancyCodes:      project.occupancyCodes || [],
    buildingClassification: project.buildingClassification,
    projectType:            project.type,
    storeysAboveGrade:      project.storeysAboveGrade,
    storeysBelowGrade:      project.storeysBelowGrade || 0,
    buildingFootprintArea:  project.buildingFootprintArea,
    adjacentStreets:        project.adjacentStreets,
    constructionType:       project.constructionType || constructionTypeFallback || null,
    highBuilding:           project.highBuilding || false,
    sprinklerSystem:        project.sprinklerSystem,
    hazardousSubstances:    project.hazardousSubstances || false,
  };

  // Drop null/empty values — matches the cleanContext filter used at confirm time.
  return Object.fromEntries(
    Object.entries(ctx).filter(([, v]) => v != null && v !== '')
  );
}
